import { ExtendedUnitFilterOptions } from '@store/types'

import { UnitFilterOptionsConfigurations } from '@adUtilities/types/apartment'
import { MinMaxInterface } from '@adUtilities/types/common'

export const getInitialConfigurations = (
  firebaseUnitFilter?: ExtendedUnitFilterOptions
): UnitFilterOptionsConfigurations => ({
  bed: {
    min: firebaseUnitFilter?.configurations?.bed?.min || '',
    max: firebaseUnitFilter?.configurations?.bed?.max || '',
  },
  study: {
    min: firebaseUnitFilter?.configurations?.study?.min || '',
    max: firebaseUnitFilter?.configurations?.study?.max || '',
  },
  bath: {
    min: firebaseUnitFilter?.configurations?.bath?.min || '',
    max: firebaseUnitFilter?.configurations?.bath?.max || '',
  },
  powderRoom: {
    min: firebaseUnitFilter?.configurations?.powderRoom?.min || '',
    max: firebaseUnitFilter?.configurations?.powderRoom?.max || '',
  },
  car: {
    min: firebaseUnitFilter?.configurations?.car?.min || '',
    max: firebaseUnitFilter?.configurations?.car?.max || '',
  },
})

export const getInitialRange = (
  firebaseUnitFilter?: ExtendedUnitFilterOptions
): MinMaxInterface => ({
  min: firebaseUnitFilter?.range?.min || '',
  max: firebaseUnitFilter?.range?.max || '',
})
